export default "__VITE_ASSET__CjFEwUu0__"